import request from '@/utils/request'

//获取校园报名动态字段
export function getField(url,query) {
    return request({
        url: url+'/participantData/signUp/getField',
        method: 'get',
        params: query
    })
}

// export function getField(url,dictType,dictValue) {
//     return request({
//         url: url + '/dict/data/typeApi/' + dictType + "/"  + dictValue,
//         method: 'get',
//     })
// }

//校园报名提交
export function compusSubmit(url,query) {
    return request({
        url: url + '/user/compusSignUp/submit',
        method: 'post',
        data: query
    })
}
//获取校园报名队伍信息
export function getparticipantDataByUserId(url,query) {
    return request({
        url: url+'/participantData/compus',
        method: 'get',
        params: query
    })
}
// 获取报名信息
export function getData(url,id) {
    return request({
        url: url + '/participantData/' + id,
        method: 'get'
    })
}

//获取权限
export function getRole(url,query) {
    return request({
        url: url+'/user/role/' + query,
        method: 'get'
    })
}
//获取报名信息
export function getParticipantData(url,query) {
    return request({
        url: url+'/participantData/list',
        method: 'get',
        params: query
    })
}


export function listBySiteIdSelectTearm(url,query) {
    return request({
        url: url + '/field/listBySiteIdSelectTearm',
        method: 'get',
        params: query
    })
}


export function getDicts(url,dictType) {
    return request({
        url: url + '/dict/data/type/' + dictType,
        method: 'get'
    })
}

export function getWorkDynamicField(url,query) {
    return request({
        url: url + '/field/getWorkDynamicField',
        method: 'get',
        params: query
    })
}

export function getWorkDynamicFieldNew(url,query) {
  return request({
    url: url + '/field/getWorkDynamicFieldNew',
    method: 'get',
    params: query
  })
}

export function getSignUpNunAndType(url,query) {
    return request({
        url: url + '/participantData/getSignUpNunAndType',
        method: 'get',
        params: query
    })
}




// WEBPACK FOOTER //
// ./src/api/info/index.js